// Storage utility for Cloudflare D1 with localStorage fallback
const USE_API = import.meta.env.PROD;

const storage = {
  async get(key) {
    try {
      if (USE_API) {
        const endpoint = key === 'ct-content' ? '/api/content' : '/api/recordings';
        const response = await fetch(endpoint);

        if (!response.ok) {
          throw new Error(`API error: ${response.statusText}`);
        }

        const data = await response.json();
        return { value: JSON.stringify(data) };
      }

      const value = localStorage.getItem(key);
      return value ? { value } : null;
    } catch (error) {
      console.error('Storage read error:', error);

      // Fallback to localStorage on API error
      try {
        const value = localStorage.getItem(key);
        return value ? { value } : null;
      } catch (e) {
        return null;
      }
    }
  },

  async set(key, value) {
    try {
      if (USE_API) {
        const endpoint = key === 'ct-content' ? '/api/content/sync' : '/api/recordings/sync';
        const dataKey = key === 'ct-content' ? 'content' : 'recordings';
        const parsedData = JSON.parse(value);

        const response = await fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ [dataKey]: parsedData })
        });

        if (!response.ok) {
          throw new Error(`API error: ${response.statusText}`);
        }

        // Also save to localStorage as backup
        localStorage.setItem(key, value);
        return;
      }

      localStorage.setItem(key, value);
    } catch (error) {
      console.error('Storage write error:', error);

      // Fallback to localStorage on API error
      try {
        localStorage.setItem(key, value);
      } catch (e) {
        console.error('localStorage fallback failed:', e);
      }
    }
  }
};

export default storage;
